var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7803",
    "data-name": "Rectangle 7803",
    width: 28,
    height: 28,
    transform: "translate(542 972)",
    fill: "#bc2727"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7840",
    "data-name": "Rectangle 7840",
    width: 19.484,
    height: 26.273,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Books",
    transform: "translate(-542 -972)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32373",
    "data-name": "Group 32373",
    transform: "translate(541.792 971.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32373-2",
    "data-name": "Group 32373",
    transform: "translate(4.466 1.143)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34566",
    "data-name": "Path 34566",
    d: "M23.95,22.562V1.143H7.169a2.7,2.7,0,0,0-2.7,2.7V24.714a2.7,2.7,0,0,0,2.692,2.7H23.95V25.611h0V22.562ZM10.2,4.235h9.969v4.11H10.2Z",
    transform: "translate(-4.466 -1.143)",
    fill: "#b3b6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34567",
    "data-name": "Path 34567",
    d: "M24.011,24.48H7.858a1.524,1.524,0,0,1,0-3.049H24.011Z",
    transform: "translate(-4.425 -0.702)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccBooks);
export default __webpack_public_path__ + "static/media/mcc_books.2c13725d1433e19465756ce6e408117d.svg";
export { ForwardRef as ReactComponent };